export const modals = {
    namespaced: true,
    state : {
        modals: []
    },
    getters : {
        getModals: state => state.modals
    },
    mutations: {
        SET_MODAL(state, payload) {
            state.modals.forEach(item => {
                item.visible = false
            })

            state.modals.push({ ...payload })
        },

        REMOVE_MODAL(state, name) {
            const modal = state.modals.findIndex(modal => modal.name === name)
            
            if (modal > 0) state.modals[modal - 1].visible = true  

            state.modals.splice(modal, 1)
        },

        CLEAR_MODALS(state) {
            state.modals = {}
        },

        TOGGLE_MODAL(state, name) {
            const modal = state.modals.findIndex(modal => modal.name === name)
            state.modals[modal].visible = !state.modals[modal].visible
        }
    },
    actions: {
        setModal({commit}, payload) {
            commit('SET_MODAL', payload)
        },
        removeModal({commit}, payload) {
            commit('REMOVE_MODAL', payload)
        },
        clearModals({commit}) {
            commit('CLEAR_MODALS')
        },
        toggleModal({commit}, name) {
            commit('TOGGLE_MODAL', name)
        }
    }
}